import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

type Choice = {
    answer: string;
    isCorrect: boolean;
  }
  
  type Question = {
    question: string;
    explanation: string;
    attachment: string;
    figure: string[];
    choices?: Choice[];
  }
  type Quiz = {
    title:string;
    questions: Question[];
  }
  type QuizEssay = {
    title:string;
    QuestionEssay: Question[]
  }
  type QuizDTO = {
    title: string;
    chapterId:string;
    lectureId:string;
    OpenLectureId:string;
    quiz:Quiz;
    QuizEssay:QuizEssay;
  } & ApiError

export const CreateExam = (data: QuizDTO): Promise<QuizDTO> => {
    return axios.post("/exam/create", data)
        .then(response => response.data as QuizDTO);
};
